export const structures = (state) => state.structures

export const getStructureById = (state) => (id) => {
  return state.structures.find(structure => structure.id === id)
}
